import { withTheme } from 'emotion-theming'
import styled from '@emotion/styled'
import PropTypes from 'prop-types'
import { withTranslation } from 'server/i18n'

import PhoneIcon from 'public/icons/phone.svg'
import BoatIcon from 'public/icons/boat-sea.svg'
import BrochureIcon from 'public/icons/brochure.svg'
import EmailIcon from 'public/icons/email.svg'
import BlockTitle from 'components/BlockTitle'
import Button from 'components/Button'

import style from './HelpBlock.style'

const HelpBlockStyled = styled.div(props => ({ ...style(props) }))

const HelpBlock = ({ t, boatID, boatName }) => {
    return (
        <HelpBlockStyled>
            <BlockTitle title={t('let-us-help-you')} subtitle={t('reach-out')} paddingLeft={0} />
            <div className="Button-Set">
                <Button variation="secondary" externalLink="tel:+385913467775">
                    <span className="icon">
                        <PhoneIcon />
                    </span>
                    <span className="content">{t('call-us')}</span>
                </Button>

                <Button
                    variation="secondary"
                    externalLink={`mailto:office@merkandmerk.com?subject=Inqury/Anfrage: ${boatName}`}>
                    <span className="icon">
                        <EmailIcon />
                    </span>
                    <span className="content">{t('e-mail-us')}</span>
                </Button>

                <Button variation="secondary" link={`/inquiry?boatID=${boatID}&type=buy`}>
                    <span className="icon">
                        <BoatIcon />
                    </span>
                    <span className="content">{t('send-inquiry')}</span>
                </Button>

                <Button variation="secondary" link={`/inquiry?boatID=${boatID}&type=buy&brochure=true`}>
                    <span className="icon">
                        <BrochureIcon />
                    </span>
                    <span className="content">{t('request-brochure')}</span>
                </Button>
            </div>
        </HelpBlockStyled>
    )
}

HelpBlock.propTypes = {
    t: PropTypes.func.isRequired,
    boatID: PropTypes.string,
    boatName: PropTypes.string
}

HelpBlock.defaultProps = {
    boatID: null,
    boatName: null
}

export default withTranslation('common')(withTheme(HelpBlock))
